export enum Profile {
    UNIT = 1,
    DISTRIBUTOR = 2,
    AGENT = 3
}